import React, { FunctionComponent, ReactNode } from 'react';
import { useClasses, IStyles } from 'app/utils/css';
import { DROPDOWN_OVERLAY_BOX_SHADOW } from 'app/constants/Styles';

export const DROPDOWN_LEFT_ALIGNED = 'left-aligned';
export const DROPDOWN_RIGHT_ALIGNED = 'right-aligned';
export const DROPDOWN_FILL_WIDTH = 'fill-width';

interface IProps {
  children?: ReactNode;
  onClick?: () => void;
  isOpen?: boolean;
  renderHidden?: boolean;
  variant?: 'fill-width' | 'left-aligned' | 'right-aligned';
  styles?: IStyles;
  // Allow to specify sizing style because Android 4.4 is sizing
  // children improperly if they use `vw` units
  maxWidth?: string;
  width?: string;
}

/**
 * Layout component that absolutely positions itself in front of other elements directly below the
 * first parent element with `position: relative`.
 */
const DropdownOverlay: FunctionComponent<IProps> = ({
  children,
  onClick,
  isOpen = true,
  renderHidden = false,
  variant = DROPDOWN_FILL_WIDTH,
  styles = {},
  maxWidth,
  width,
}) => {
  const classes = useClasses({
    overlay: [
      {
        display: 'none',
        zIndex: 1,
        backgroundColor: 'white',
        borderTop: 'none',
        boxShadow: DROPDOWN_OVERLAY_BOX_SHADOW,
        position: 'absolute',
        top: '100%',
        minWidth: '100%',
        maxWidth,
        width,
      },

      variant === DROPDOWN_FILL_WIDTH && {
        left: 0,
        right: 0,
      },

      variant === DROPDOWN_LEFT_ALIGNED && {
        left: 0,
      },

      variant === DROPDOWN_RIGHT_ALIGNED && {
        right: 0,
      },

      isOpen && {
        display: 'block',
        ...styles,
      },
    ],
  });

  if (!renderHidden && !isOpen) {
    return null;
  }

  return <div data-testid="dropdown-overlay" onClick={onClick} className={classes.overlay}>
    {children}
  </div>;
};

export default DropdownOverlay;
